// This file is automatically generated. DO NOT EDIT.

import { type SlidePace } from '../../../../types/response/SlidePace';
import { type SlideDeckPace } from '../../../../types/response/SlideDeckPace';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetPaceDataResponse {
  /** The pace data associated with the slides in a series. */
  slidePaces: Array<SlidePace>;
  /** The pace data associated with the slides in a migrated slide deck. */
  slideDeckPaces: Array<SlideDeckPace>;
}

export async function getPaceDataResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetPaceDataResponse>,
): Promise<GetPaceDataResponse> {
  return getJSONResponse<GetPaceDataResponse>(
    response,
    'getPaceDataResponse',
    options,
  );
}
